import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgC2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7220_21630)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 100,
			height: 100,
			fill: "#60A5FA"
		}), /* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_7220_21630)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M49.9953 74.1969C49.3301 74.1969 48.788 74.7372 48.788 75.4056V75.4747C48.7888 75.5008 48.7893 75.527 48.7893 75.5533V85.2115C48.7893 86.545 47.7082 87.626 46.3747 87.626H25.2475C21.247 87.626 18.0039 84.3829 18.0039 80.3824C18.0039 76.3819 21.247 73.1388 25.2475 73.1388H30.8106C31.9327 63.5399 40.0926 56.0879 49.9953 56.0879C59.8477 56.0879 67.9722 63.465 69.1617 72.9896H74.746C78.7466 72.9896 81.9896 76.2326 81.9896 80.2332C81.9896 84.2337 78.7465 87.4768 74.746 87.4768H53.6188C52.2853 87.4768 51.2043 86.3958 51.2043 85.0622V77.3938C51.2031 77.3344 51.2025 77.2748 51.2025 77.2151V75.4074C51.2025 74.737 50.6583 74.1969 49.9953 74.1969Z",
					fill: "url(#paint0_linear_7220_21630)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 49.9982,
					cy: 43.4104,
					r: 30.7854,
					fill: "url(#paint1_radial_7220_21630)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.752 42.2036C42.752 40.8701 43.833 39.7891 45.1665 39.7891C46.5 39.7891 47.581 40.8701 47.581 42.2036V44.6181C47.581 45.9516 46.5 47.0327 45.1665 47.0327C43.833 47.0327 42.752 45.9517 42.752 44.6181V42.2036Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M52.4111 42.2036C52.4111 40.8701 53.4922 39.7891 54.8257 39.7891C56.1592 39.7891 57.2402 40.8701 57.2402 42.2036V44.6181C57.2402 45.9516 56.1592 47.0327 54.8257 47.0327C53.4922 47.0327 52.4111 45.9517 52.4111 44.6181V42.2036Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 42.149,
					cy: 43.4097,
					r: 7.84725,
					stroke: "#395FE2",
					strokeWidth: 1.8109
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 57.8424,
					cy: 43.4097,
					r: 7.84725,
					stroke: "#395FE2",
					strokeWidth: 1.8109
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M79.5345 52.11C73.7569 60.2448 62.694 65.7461 49.9957 65.7461C37.2961 65.7461 26.2321 60.2436 20.4551 52.1074C24.2076 64.8753 36.0128 74.197 49.9952 74.197C63.9766 74.197 75.7812 64.8765 79.5345 52.11Z",
					fill: "#395FE2"
				})
			]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_7220_21630",
			x: -10.1217,
			y: -15.5006,
			width: 120.237,
			height: 131.253,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 14.0628 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.574121 0 0 0 0 0.850942 0 0 0 0 1 0 0 0 1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_7220_21630"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_7220_21630",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_7220_21630",
			x1: 66.5968,
			y1: 73.1396,
			x2: 66.5968,
			y2: 87.626,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#BFDBFE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E0E7FF"
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint1_radial_7220_21630",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(49.9982 43.4104) rotate(90) scale(30.7854)",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#BFDBFE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DBEAFE"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_7220_21630",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 100,
				height: 100,
				fill: "white"
			})
		})
	] })]
});
export default SvgC2;
